const meta = {
  slug: 'rams-49ers-week1-preview',
  title: 'Rams vs 49ers Week 1 Thursday Night Preview: Start/Sit, Injuries, and IDP Streamers',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'The NFL goes international as the Rams and 49ers meet at Melbourne Cricket Ground on Thursday Night Football. LA is a 3.5-point favorite behind an MVP quarterback and a rebuilt defense featuring Myles Garrett and Aaron Donald. Start/sit calls, the CMC watch, and the IDP streamers for the Melbourne opener.',
  readMinutes: 11,
  date: '2026-09-10',
};

export default meta;
